<template>
  <div class="footer">
    <p class="footer-title">Комментарий</p>
    <textarea v-model="comment" @input="addComment()"></textarea>
  </div>
</template>
<script>
export default {
  props: ["collection", "element", "productInfo"],
  data: () => ({
    comment: ""
  }),
  methods: {
    addComment(){
        let miniCart = this.$localStorageGet("miniCart");
        let currentcartItem = miniCart.baskets.find((x) => x.productId == this.element);
        if (currentcartItem) {
            currentcartItem.comment = this.comment;
        }else{
            let data = {
                collectionID: this.collection,
                productId: this.element,
                productName: this.productInfo.name,
                comment: this.comment,
                offers: []
            }
            miniCart.baskets.push(data)
        }
        this.$localStorageSet('miniCart', miniCart);
    },
    startComponent(){
      this.comment = "";
      let miniCart = this.$localStorageGet("miniCart");
      let currentcartItem = miniCart.baskets.find(
        (x) => x.productId == this.element
      );
      if (currentcartItem) {
          this.comment = currentcartItem.comment;
      }
    }
  },
  created() {
    this.startComponent();
  },
  watch: {
    '$route'(){
      this.startComponent();
    }
  }
};
</script>
<style lang="scss" scoped>
.footer {
  width: 100%;
  height: 110px;
  .footer-title {
    width: 100%;
    background: rgba(196, 196, 196, 0.24);
    font-size: 12px;
    font-weight: bold;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  textarea {
    width: 100%;
    height: 80px;
    font-size: 12px;
    margin-top: 4px;
    padding: 5px;
  }
}
</style>